import PlusUpsell from './PlusUpsell';

export default PlusUpsell;
